import { axios } from "@/client/libs/axios";
import { creditBalanceSchema, UserWithSecrets } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export const getUserById = async (id: string) => {
  const user = await axios.get<UserWithSecrets, AxiosResponse<UserWithSecrets>>(`user/${id}`);
  const validCredit = await axios.get<unknown>(`credit/balance/${id}`);
  const balance = creditBalanceSchema.parse(validCredit.data);
  return {
    ...user.data,
    credit: balance.credit,
    creditExpiring: balance.expiring,
    creditExpired: balance.expired,
  };
};

export const useGetUser = (id?: string) => {
  const {
    data: user,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["user", id],
    queryFn: () => getUserById(id!),
    enabled: !!id,
  });

  return { user, error, isLoading };
};
